import * as React from "react";
type Props = {
  className?: string,
};
function SvgUtensils({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-utensils"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 7.5V4C10 3.44772 10.4477 3 11 3C11.5523 3 12 3.44772 12 4V7C12 8.49088 11.1844 9.79125 9.97496 10.4792C9.43531 10.7862 9 11.3079 9 11.9288V20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20V11.9288C7 11.3079 6.56469 10.7862 6.02504 10.4792C4.81564 9.79125 4 8.49088 4 7V4C4 3.44772 4.44772 3 5 3C5.55228 3 6 3.44772 6 4V7.5C6 7.77614 6.22386 8 6.5 8C6.77614 8 7 7.77614 7 7.5V4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4V7.5C9 7.77614 9.22386 8 9.5 8C9.77614 8 10 7.77614 10 7.5ZM20 3C17.5813 3.60468 15.7695 5.61358 15.4169 8.08166L15.0282 10.8029C15.0094 10.9341 15 11.0665 15 11.1991C15 12.746 16.254 14 17.8009 14H18V20C18 20.5523 18.4477 21 19 21C19.5523 21 20 20.5523 20 20V3Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgUtensils;
